import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSideTab } from "../../../toolkit/slices/inventories/inventorySlice";
import accessCheckPromise from "../../../../utils/accessCheck";
import { logoutUser } from "../../../toolkit/slices/users/userSlice";
import AuthorizationError from "../AuthorizationError";
import { Card, Row, Col, Typography, Tabs } from "antd";
import "./reportHoverStyles.css";
import {
  FaUsers,
  FaChartBar,
  FaUserTie,
  FaCalendarAlt,
  FaHandshake,
  FaFileInvoiceDollar,
} from "react-icons/fa";
import { HiTrendingUp } from "react-icons/hi";
import { AiOutlineFileDone } from "react-icons/ai";
import { FcSalesPerformance } from "react-icons/fc";
import { GiProfit } from "react-icons/gi";
import PartyMasterReport from "./components/PartyMasterReport";
import IndustryWiseReport from "./components/IndustryWiseReport";
// import SalesmanWiseReport from "./components/SalesmanWiseReportOld";
import PropertyWiseMonthlySales from "./components/PropertyWiseMonthlySales";
import PartyWiseMonthlySales from "./components/PartyWiseMonthlySales";
import SOPendingForBillReport from "./components/SOPendingForBillReport";
import OccupancyReport from "./components/OccupancyReport";
import TenderOverReport from "./components/TenderOverReport";
import TopCustomerReport from "./components/TopCustomerReport";
import SalesOrderReport from "./components/SalesOrderReport";
import PropertyWisePLReport from "./components/PropertyWisePLReport";
import { GrGroup } from "react-icons/gr";
import PoSoSalesBillReport from "./components/PoSoSalesBillReport";
import BusinessMemorandumReport from "./components/BusinessMemorandumReport";
import PropertyAndMediaWiseSalesReport from "./components/PropertyAndMediaWiseSalesReport";
import PropertyAndMediaWisePurchaseReport from "./components/PropertyAndMediaWisePurchaseReport";
import SalesOrderEntryReport from "./components/SalesOrderEntryReport";
import BillEntryReport from "./components/BillEntryReport";
import BDFReport from "./components/BDFReport";
import BDFNotSentToSalesOrderReport from "./components/BDFNotSentToSalesOrderReport";
import SalesRegisterReport from "./components/SalesRegisterReport";
import CreditNoteRegisterReport from "./components/CreditNoteRegisterReport";

import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import SalesmanWiseReport from "./components/SalesmanWiseReport";
import GroupWiseMonthlySalesReport from "./components/GroupWiseMonthlySalesReport";

const { Title } = Typography;

const ReportContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [access, setAccess] = useState(false);

  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch(() => dispatch(logoutUser()));
  }, [dispatch]);

  if (!access) return <AuthorizationError />;

  const reports = [
    {
      slug: "party-master",
      title: "Party Master",
      icon: <FaUsers style={{ fontSize: 24, color: "#1890ff" }} />,
      component: PartyMasterReport,
    },
    {
      slug: "industry-wise",
      title: "Industry Wise Report",
      icon: <FaChartBar style={{ fontSize: 24, color: "#52c41a" }} />,
      component: IndustryWiseReport,
    },
    {
      slug: "property-wise-monthly",
      title: "Property Wise Monthly Sales",
      icon: <FaCalendarAlt style={{ fontSize: 24, color: "#722ed1" }} />,
      component: PropertyWiseMonthlySales,
    },
    {
      slug: "party-wise-monthly",
      title: "Party Wise Monthly Sales",
      icon: <FaHandshake style={{ fontSize: 24, color: "#eb2f96" }} />,
      component: PartyWiseMonthlySales,
    },
    {
      slug: "so-pending-for-bill",
      title: "SO Pending For Bill Report",
      icon: <FaFileInvoiceDollar style={{ fontSize: 24, color: "#13c2c2" }} />,
      component: SOPendingForBillReport,
    },
    {
      slug: "occupancy-report",
      title: "Occupancy Report",
      icon: <FaChartBar style={{ fontSize: 24, color: "#f5222d" }} />,
      component: OccupancyReport,
    },
    {
      slug: "tenderover-report",
      title: "Tender Over Report",
      icon: <AiOutlineFileDone style={{ fontSize: 24, color: "#f5222d" }} />,
      component: TenderOverReport,
    },
    {
      slug: "top-customers",
      title: "Top Customers Report",
      icon: <HiTrendingUp style={{ fontSize: 24, color: "#f5222d" }} />,
      component: TopCustomerReport,
    },
    {
      slug: "sales-order",
      title: "Sales Order Report",
      icon: <FcSalesPerformance style={{ fontSize: 24, color: "#f5222d" }} />,
      component: SalesOrderReport,
    },
    {
      slug: "property-wise-pl",
      title: "Property Wise Profit & Loss Report",
      icon: <GiProfit style={{ fontSize: 24, color: "#f5222d" }} />,
      component: PropertyWisePLReport,
    },
     {
      slug: "salesman-wise",
      title: "Salesman Wise Report",
      icon: <FaUserTie style={{ fontSize: 24, color: "#fa8c16" }} />,
      component: SalesmanWiseReport,
    },
     {
      slug: "groupwise-monthly-sales",
      title: "Group Wise Monthly Sales",
      icon: <GrGroup  style={{ fontSize: 24, color: "#fa8c16" }} />,
      component: GroupWiseMonthlySalesReport,
    },
    {
      slug: "po-so-sales-bill",
      title: "PO → SO → Sales → Bill Report",
      icon: <FaFileInvoiceDollar style={{ fontSize: 24, color: "#2f54eb" }} />,
      component: PoSoSalesBillReport,
    },
    {
      slug: "business-memorandum",
      title: "Business Memorandum",
      icon: <AiOutlineFileDone style={{ fontSize: 24, color: "#389e0d" }} />,
      component: BusinessMemorandumReport,
    },
    {
      slug: "property-media-wise-sales",
      title: "Property & Media-Wise Sales",
      icon: <FaChartBar style={{ fontSize: 24, color: "#597ef7" }} />,
      component: PropertyAndMediaWiseSalesReport,
    },
    {
      slug: "property-media-wise-purchase",
      title: "Property & Media-Wise Purchase",
      icon: <FaChartBar style={{ fontSize: 24, color: "#9254de" }} />,
      component: PropertyAndMediaWisePurchaseReport,
    },
    {
      slug: "sales-order-entry",
      title: "Sales Order Entry",
      icon: <FaFileInvoiceDollar style={{ fontSize: 24, color: "#1890ff" }} />,
      component: SalesOrderEntryReport,
    },
    {
      slug: "bill-entry",
      title: "Bill Entry",
      icon: <FaFileInvoiceDollar style={{ fontSize: 24, color: "#52c41a" }} />,
      component: BillEntryReport,
    },
    {
      slug: "bdf-report",
      title: "BDF Report",
      icon: <FaFileInvoiceDollar style={{ fontSize: 24, color: "#722ed1" }} />,
      component: BDFReport,
    },
    {
      slug: "bdf-not-sent-to-so",
      title: "BDF Not Sent to Sales Order",
      icon: <FaFileInvoiceDollar style={{ fontSize: 24, color: "#d4380d" }} />,
      component: BDFNotSentToSalesOrderReport,
    },
    {
      slug: "sales-register",
      title: "Sales Register Report",
      icon: <FaFileInvoiceDollar style={{ fontSize: 24, color: "#eb2f96" }} />,
      component: SalesRegisterReport,
    },
    {
      slug: "credit-note-register",
      title: "Credit Note Register",
      icon: <FaFileInvoiceDollar style={{ fontSize: 24, color: "#13c2c2" }} />,
      component: CreditNoteRegisterReport,
    },
  ];

  const salesOrderReportSlugs = new Set([
    "property-media-wise-sales",
    "property-wise-monthly",
    "party-wise-monthly",
    "sales-order",
    "salesman-wise",
    "groupwise-monthly-sales",
  ]);

  const purchaseOrderReportSlugs = new Set(["property-media-wise-purchase"]);

  const salesOrderReports = reports.filter((r) => salesOrderReportSlugs.has(r.slug));
  const purchaseOrderReports = reports.filter((r) => purchaseOrderReportSlugs.has(r.slug));
  const otherReports = reports.filter(
    (r) => !salesOrderReportSlugs.has(r.slug) && !purchaseOrderReportSlugs.has(r.slug)
  );

  const ReportGrid = ({ data, onSelect }) => (
    <Row gutter={[16, 16]}>
      {data.map((report) => (
        <Col xs={24} sm={12} lg={8} xl={6} key={report.slug}>
          <Card
            hoverable
            onClick={() => onSelect(report)}
            style={{
              borderRadius: 12,
              border: "2px solid #1890ff20",
              height: 180,
              display: "flex",
              flexDirection: "column",
            }}
            bodyStyle={{
              padding: 16,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <div>
              <div style={{ marginBottom: 8 }}>{report.icon}</div>
              <Title style={{ fontSize: 16 }}>{report.title}</Title>
            </div>

            <span style={{ color: "#1890ff" }}>View Details</span>
          </Card>
        </Col>
      ))}
    </Row>
  );

  const Dashboard = ({ activeTab }) => {
    const location = useLocation();
    const isSalesOrderRoute = location.pathname.includes("/reports/sales-order");
    const isPurchaseOrderRoute = location.pathname.includes("/reports/purchase-order");

    const resolvedActiveTab =
      activeTab ??
      (isSalesOrderRoute ? "sales-order" : isPurchaseOrderRoute ? "purchase-order" : "other");

    return (
      <div
        className="parent-padding-container"
        style={{
          backgroundColor: "white",
          borderRadius: 12,
          padding: 20,
          minHeight: "100vh",
        }}
      >
        <Tabs
          activeKey={resolvedActiveTab}
          onChange={(key) => {
            if (key === "sales-order") navigate("/reports/sales-order");
            if (key === "purchase-order") navigate("/reports/purchase-order");
            if (key === "other") navigate("/reports/other");
          }}
          items={[
            {
              key: "sales-order",
              label: "Sales Order Reports",
              children: (
                <ReportGrid
                  data={salesOrderReports}
                  onSelect={(report) =>
                    navigate(`/reports/sales-order/${report.slug}`)
                  }
                />
              ),
            },
            {
              key: "purchase-order",
              label: "Purchase Order Reports",
              children: (
                <ReportGrid
                  data={purchaseOrderReports}
                  onSelect={(report) =>
                    navigate(`/reports/purchase-order/${report.slug}`)
                  }
                />
              ),
            },
            {
              key: "other",
              label: "Other Reports",
              children: (
                <ReportGrid
                  data={otherReports}
                  onSelect={(report) => navigate(`/reports/other/${report.slug}`)}
                />
              ),
            },
          ]}
        />
      </div>
    );
  };

  // 🔹 Slug Page Renderer
  const ReportSlugPage = () => {
    const location = useLocation();
    const { slug } = useParams();
    const report = reports.find((r) => r.slug === slug);
    if (!report) return <Navigate to="/reports" replace />;

    const backPath = location.pathname.includes("/reports/other/")
      ? "/reports/other"
      : location.pathname.includes("/reports/purchase-order/")
      ? "/reports/purchase-order"
      : slug && purchaseOrderReportSlugs.has(slug)
      ? "/reports/purchase-order"
      : slug && salesOrderReportSlugs.has(slug)
      ? "/reports/sales-order"
      : "/reports";

    const Component = report.component;
    return (
      <div className="report-container-root">
        <Component onBack={() => navigate(backPath)} />
      </div>
    );
  };

  // 🔹 Sales Order nested slug renderer (/reports/sales-order/:slug)
  const SalesOrderReportSlugPage = () => {
    const { slug } = useParams();
    const report = salesOrderReports.find((r) => r.slug === slug);
    if (!report) return <Navigate to="/reports" replace />;

    const Component = report.component;
    return (
      <div className="report-container-root">
        <Component onBack={() => navigate("/reports/sales-order")} />
      </div>
    );
  };

  // 🔹 Purchase Order nested slug renderer (/reports/purchase-order/:slug)
  const PurchaseOrderReportSlugPage = () => {
    const { slug } = useParams();
    const report = purchaseOrderReports.find((r) => r.slug === slug);
    if (!report) return <Navigate to="/reports" replace />;

    const Component = report.component;
    return (
      <div className="report-container-root">
        <Component onBack={() => navigate("/reports/purchase-order")} />
      </div>
    );
  };

  return (
    <Routes>
      <Route index element={<Navigate to="sales-order" replace />} />
      <Route path="sales-order" element={<Dashboard activeTab="sales-order" />} />
      <Route path="sales-order/:slug" element={<SalesOrderReportSlugPage />} />
      <Route path="purchase-order" element={<Dashboard activeTab="purchase-order" />} />
      <Route path="purchase-order/:slug" element={<PurchaseOrderReportSlugPage />} />
      <Route path="other" element={<Dashboard activeTab="other" />} />
      <Route path="other/:slug" element={<ReportSlugPage />} />
      <Route path=":slug" element={<ReportSlugPage />} />
      <Route path="*" element={<Navigate to="/reports" replace />} />
    </Routes>
  );
};

export default ReportContainer;